const response = {
    "events": [
      {
        "event": "a11aa449-7721-4c03-b171-b930a35bff2c",
        "session": "5216f698-e8ff-44fc-a310-edf66f971d8b",
        "best_id": "its-trace-use",
        "device": "dev:864475044231362",
        "sn": "its-trace-use",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660328856.574568,
        "req": "note.add",
        "when": 1660328806,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 13,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 590,
          "c00_50": 176,
          "c01_00": 17,
          "csamples": 38,
          "csecs": 60,
          "humidity": 44.083626,
          "motion": 97,
          "pm01_0": 2.131579,
          "pm01_0_rstd": 0.5019531,
          "pm02_5": 3.1052632,
          "pm02_5_rstd": 0.34960938,
          "pm10_0": 3.1052632,
          "pm10_0_rstd": 0.34960938,
          "pressure": 101301.23,
          "sensor": "pms7003",
          "temperature": 25.931004,
          "voltage": 4.1835938
        },
        "best_location_type": "tower",
        "best_location_when": 1660328854,
        "best_lat": 39.949806,
        "best_lon": -75.242095,
        "best_location": "Philadelphia Pennsylvania",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "tower_when": 1660328854,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "3968d8f1-1129-4a36-840c-ad505d4bf7e8",
        "session": "07f9d381-f462-4270-9b6c-3a011750a07d",
        "best_id": "its-trace-use",
        "device": "dev:864475044231362",
        "sn": "its-trace-use",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660332472.320829,
        "req": "note.add",
        "when": 1660330693,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 0,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 148,
          "c00_50": 35,
          "c01_00": 4,
          "csamples": 71,
          "csecs": 60,
          "humidity": 43.088383,
          "motion": 161,
          "pm02_5": 0.056338027,
          "pm02_5_rstd": 4.1210938,
          "pm10_0": 0.056338027,
          "pm10_0_rstd": 4.1210938,
          "pressure": 101315.88,
          "sensor": "pms7003",
          "temperature": 29.768211,
          "voltage": 4.2070312
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660332472,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "fdf36004-dc24-42ab-b4a2-b580dbd1d578",
        "session": "07f9d381-f462-4270-9b6c-3a011750a07d",
        "best_id": "its-trace-use",
        "device": "dev:864475044231362",
        "sn": "its-trace-use",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660332472.324755,
        "req": "note.add",
        "when": 1660331585,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 6,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 397,
          "c00_50": 118,
          "c01_00": 16,
          "c02_50": 1,
          "charging": true,
          "csamples": 58,
          "csecs": 60,
          "humidity": 31.7374,
          "motion": 137,
          "pm01_0": 0.8448276,
          "pm01_0_rstd": 0.76171875,
          "pm02_5": 1.5172414,
          "pm02_5_rstd": 0.41381836,
          "pm10_0": 1.5172414,
          "pm10_0_rstd": 0.41381836,
          "pressure": 101285.25,
          "sensor": "pms7003",
          "temperature": 32.97803,
          "voltage": 4.2148438
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660332472,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "9933ee98-2836-48b3-857f-9eb5226d7a91",
        "session": "be24b765-4cc2-4ead-8718-fe3a3f1cc449",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660336149.452687,
        "req": "note.add",
        "when": 1660332615,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 5,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 393,
          "c00_50": 114,
          "c01_00": 13,
          "charging": true,
          "csamples": 71,
          "csecs": 60,
          "humidity": 24.99527,
          "motion": 9,
          "pm01_0": 0.6056338,
          "pm01_0_rstd": 0.859375,
          "pm02_5": 1.3098592,
          "pm02_5_rstd": 0.49291992,
          "pm10_0": 1.3098592,
          "pm10_0_rstd": 0.49291992,
          "pressure": 101258.1,
          "sensor": "pms7003",
          "temperature": 36.331688,
          "voltage": 4.234375
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660336149,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "f399467e-1cef-4c5b-90ba-bd5f232ee159",
        "session": "be24b765-4cc2-4ead-8718-fe3a3f1cc449",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660336149.455239,
        "req": "note.add",
        "when": 1660333376,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 11,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 493,
          "c00_50": 147,
          "c01_00": 23,
          "c02_50": 2,
          "charging": true,
          "csamples": 47,
          "csecs": 60,
          "humidity": 23.291166,
          "pm01_0": 1.4042553,
          "pm01_0_rstd": 0.38330078,
          "pm02_5": 2.787234,
          "pm02_5_rstd": 0.25854492,
          "pm10_0": 3.4255319,
          "pm10_0_rstd": 0.20861816,
          "pressure": 101265.14,
          "sensor": "pms7003",
          "temperature": 37.86867,
          "voltage": 4.2578125
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660336149,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "7c1f3f45-643a-4cb7-af76-9a1801c92679",
        "session": "be24b765-4cc2-4ead-8718-fe3a3f1cc449",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660336149.462578,
        "req": "note.add",
        "when": 1660334276,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 9,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 501,
          "c00_50": 152,
          "c01_00": 19,
          "c02_50": 1,
          "charging": true,
          "csamples": 48,
          "csecs": 60,
          "humidity": 20.50218,
          "pm01_0": 1.3333334,
          "pm01_0_rstd": 0.3894043,
          "pm02_5": 2.2708333,
          "pm02_5_rstd": 0.32421875,
          "pm10_0": 2.2708333,
          "pm10_0_rstd": 0.32421875,
          "pressure": 101259.73,
          "sensor": "pms7003",
          "temperature": 39.474735,
          "voltage": 4.265625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660336149,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "68aa58fe-ae88-45bb-acd7-2defb66caeb4",
        "session": "be24b765-4cc2-4ead-8718-fe3a3f1cc449",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660336149.478542,
        "req": "note.add",
        "when": 1660335178,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 6,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 341,
          "c00_50": 102,
          "c01_00": 14,
          "charging": true,
          "csamples": 61,
          "csecs": 60,
          "humidity": 21.828482,
          "pm01_0": 1,
          "pm01_0_rstd": 0.44726562,
          "pm02_5": 1.590164,
          "pm02_5_rstd": 0.36987305,
          "pm10_0": 1.590164,
          "pm10_0_rstd": 0.36987305,
          "pressure": 101266.2,
          "sensor": "pms7003",
          "temperature": 38.287064,
          "voltage": 4.296875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660336149,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "cf730f68-2d21-4b0f-8846-3cd74dc3497a",
        "session": "be24b765-4cc2-4ead-8718-fe3a3f1cc449",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660336149.487334,
        "req": "note.add",
        "when": 1660336077,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 10,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 472,
          "c00_50": 140,
          "c01_00": 14,
          "charging": true,
          "csamples": 42,
          "csecs": 60,
          "humidity": 22.847345,
          "pm01_0": 1.3809524,
          "pm01_0_rstd": 0.42163086,
          "pm02_5": 2.3095238,
          "pm02_5_rstd": 0.30981445,
          "pm10_0": 2.3095238,
          "pm10_0_rstd": 0.30981445,
          "pressure": 101271.17,
          "sensor": "pms7003",
          "temperature": 36.255478,
          "voltage": 4.3046875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660336149,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "c169c62d-d7ce-44b8-86eb-5a03ee87a05e",
        "session": "7dfcba82-e222-42e4-975a-f96dbdcc4d22",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660339695.258153,
        "req": "note.add",
        "when": 1660336976,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 7,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 366,
          "c00_50": 110,
          "c01_00": 19,
          "charging": true,
          "csamples": 63,
          "csecs": 60,
          "humidity": 21.294024,
          "pm01_0": 0.74603176,
          "pm01_0_rstd": 0.7973633,
          "pm02_5": 1.6984127,
          "pm02_5_rstd": 0.40454102,
          "pm10_0": 1.6984127,
          "pm10_0_rstd": 0.40454102,
          "pressure": 101260.51,
          "sensor": "pms7003",
          "temperature": 36.743935,
          "voltage": 4.265625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660339694,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "01153775-0cc5-4a82-8b31-baadbf0027af",
        "session": "7dfcba82-e222-42e4-975a-f96dbdcc4d22",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660339695.259676,
        "req": "note.add",
        "when": 1660337876,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 312,
          "c00_50": 81,
          "c01_00": 8,
          "csamples": 71,
          "csecs": 60,
          "humidity": 20.65495,
          "pm01_0": 0.53521127,
          "pm01_0_rstd": 0.93847656,
          "pm02_5": 0.6619718,
          "pm02_5_rstd": 0.9536133,
          "pm10_0": 0.6619718,
          "pm10_0_rstd": 0.9536133,
          "pressure": 101267.305,
          "sensor": "pms7003",
          "temperature": 36.478992,
          "voltage": 4.2695312
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660339694,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "88aeab9b-0370-4099-84b4-839ba63cf912",
        "session": "7dfcba82-e222-42e4-975a-f96dbdcc4d22",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660339695.261215,
        "req": "note.add",
        "when": 1660338776,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 322,
          "c00_50": 91,
          "c01_00": 15,
          "csamples": 69,
          "csecs": 60,
          "humidity": 23.094942,
          "pm01_0": 0.39130434,
          "pm01_0_rstd": 1.3310547,
          "pm02_5": 0.6086956,
          "pm02_5_rstd": 1.0625,
          "pm10_0": 1.1884058,
          "pm10_0_rstd": 0.9042969,
          "pressure": 101267.88,
          "sensor": "pms7003",
          "temperature": 33.88893,
          "voltage": 4.3007812
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660339694,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "d7ae6e50-fd76-4c40-bb54-fdc79c9523ef",
        "session": "7dfcba82-e222-42e4-975a-f96dbdcc4d22",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660339695.262556,
        "req": "note.add",
        "when": 1660339676,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 5,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 332,
          "c00_50": 94,
          "c01_00": 14,
          "csamples": 71,
          "csecs": 60,
          "humidity": 24.674538,
          "pm01_0": 0.46478873,
          "pm01_0_rstd": 1.0810547,
          "pm02_5": 1.1690141,
          "pm02_5_rstd": 0.578125,
          "pm10_0": 1.4084507,
          "pm10_0_rstd": 0.6303711,
          "pressure": 101277.87,
          "sensor": "pms7003",
          "temperature": 32.052307,
          "voltage": 4.3203125
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660339694,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "bfae52da-3f3a-46ec-87ee-e1385a14eca6",
        "session": "391066f6-927a-41ad-a464-ff376469f4ae",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660343341.122778,
        "req": "note.add",
        "when": 1660340576,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 3,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 296,
          "c00_50": 84,
          "c01_00": 12,
          "csamples": 69,
          "csecs": 60,
          "humidity": 25.414711,
          "pm01_0": 0.3768116,
          "pm01_0_rstd": 1.3730469,
          "pm02_5": 0.82608694,
          "pm02_5_rstd": 0.7470703,
          "pm10_0": 0.82608694,
          "pm10_0_rstd": 0.7470703,
          "pressure": 101280.086,
          "sensor": "pms7003",
          "temperature": 30.75324,
          "voltage": 4.296875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660343340,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "07de8e0d-5126-4864-9918-9650455f98b7",
        "session": "391066f6-927a-41ad-a464-ff376469f4ae",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660343341.129215,
        "req": "note.add",
        "when": 1660341476,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 14,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 628,
          "c00_50": 185,
          "c01_00": 17,
          "c02_50": 1,
          "csamples": 44,
          "csecs": 60,
          "humidity": 27.690794,
          "pm01_0": 2.5227273,
          "pm01_0_rstd": 0.8823242,
          "pm02_5": 3.409091,
          "pm02_5_rstd": 0.875,
          "pm10_0": 3.6818182,
          "pm10_0_rstd": 0.9638672,
          "pressure": 101273.35,
          "sensor": "pms7003",
          "temperature": 29.862827,
          "voltage": 4.296875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660343340,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "75f652a7-8ce9-464e-8366-4fbb8d0b4f5e",
        "session": "391066f6-927a-41ad-a464-ff376469f4ae",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660343341.136916,
        "req": "note.add",
        "when": 1660342376,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 9,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 455,
          "c00_50": 138,
          "c01_00": 22,
          "csamples": 50,
          "csecs": 60,
          "humidity": 28.731237,
          "pm01_0": 1.22,
          "pm01_0_rstd": 0.5048828,
          "pm02_5": 2.18,
          "pm02_5_rstd": 0.5839844,
          "pm10_0": 2.28,
          "pm10_0_rstd": 0.55371094,
          "pressure": 101270.97,
          "sensor": "pms7003",
          "temperature": 29.429132,
          "voltage": 4.2929688
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660343340,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "81e60d12-13d6-4599-8931-216b92d7fae5",
        "session": "391066f6-927a-41ad-a464-ff376469f4ae",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660343341.142903,
        "req": "note.add",
        "when": 1660343276,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 5,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 341,
          "c00_50": 102,
          "c01_00": 17,
          "c02_50": 1,
          "c05_00": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 28.209099,
          "pm01_0": 0.52112675,
          "pm01_0_rstd": 0.96533203,
          "pm02_5": 1.1549295,
          "pm02_5_rstd": 0.3774414,
          "pm10_0": 1.9014084,
          "pm10_0_rstd": 0.33447266,
          "pressure": 101268.76,
          "sensor": "pms7003",
          "temperature": 29.018452,
          "voltage": 4.3085938
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660343340,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "3c9de5f5-b281-4b2c-a57e-f522c81f1942",
        "session": "a6f1a12e-6cf1-41ef-90d7-d5fe5699bd6f",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660346899.090648,
        "req": "note.add",
        "when": 1660344176,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 302,
          "c00_50": 92,
          "c01_00": 11,
          "csamples": 71,
          "csecs": 60,
          "humidity": 28.189232,
          "pm01_0": 0.47887325,
          "pm01_0_rstd": 1.0507812,
          "pm02_5": 1.0704225,
          "pm02_5_rstd": 0.7290039,
          "pm10_0": 1.0704225,
          "pm10_0_rstd": 0.7290039,
          "pressure": 101266.88,
          "sensor": "pms7003",
          "temperature": 28.618004,
          "voltage": 4.2617188
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660346898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "508815e9-785e-4f84-b5d4-705a7f197125",
        "session": "a6f1a12e-6cf1-41ef-90d7-d5fe5699bd6f",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660346899.094901,
        "req": "note.add",
        "when": 1660345076,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 220,
          "c00_50": 67,
          "c01_00": 6,
          "csamples": 71,
          "csecs": 60,
          "humidity": 27.762558,
          "pm01_0": 0.2535211,
          "pm01_0_rstd": 1.7285156,
          "pm02_5": 0.53521127,
          "pm02_5_rstd": 0.93847656,
          "pm10_0": 0.53521127,
          "pm10_0_rstd": 0.93847656,
          "pressure": 101276.914,
          "sensor": "pms7003",
          "temperature": 28.188917,
          "voltage": 4.2617188
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660346898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "43758860-60f6-475c-8394-cff34fda72f4",
        "session": "a6f1a12e-6cf1-41ef-90d7-d5fe5699bd6f",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660346899.099399,
        "req": "note.add",
        "when": 1660345976,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 7,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 350,
          "c00_50": 104,
          "c01_00": 15,
          "c02_50": 1,
          "csamples": 69,
          "csecs": 60,
          "humidity": 28.437046,
          "pm01_0": 0.5797101,
          "pm01_0_rstd": 0.90722656,
          "pm02_5": 1.7391304,
          "pm02_5_rstd": 0.9794922,
          "pm10_0": 1.942029,
          "pm10_0_rstd": 1.0517578,
          "pressure": 101280.97,
          "sensor": "pms7003",
          "temperature": 27.941898,
          "voltage": 4.2890625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660346898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "6951fc25-8920-4035-877b-8defe238e302",
        "session": "a6f1a12e-6cf1-41ef-90d7-d5fe5699bd6f",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660346899.104044,
        "req": "note.add",
        "when": 1660346876,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 3,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 232,
          "c00_50": 73,
          "c01_00": 5,
          "csamples": 71,
          "csecs": 60,
          "humidity": 28.789173,
          "pm01_0": 0.64788735,
          "pm01_0_rstd": 0.7426758,
          "pm02_5": 0.7746479,
          "pm02_5_rstd": 0.85058594,
          "pm10_0": 0.7746479,
          "pm10_0_rstd": 0.85058594,
          "pressure": 101289.95,
          "sensor": "pms7003",
          "temperature": 27.556286,
          "voltage": 4.3046875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660346898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "efaaf1ef-ee95-4c05-a5b9-b14ed50f154f",
        "session": "ae550e74-ae22-490a-9c9a-c2df385f9785",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660350494.496445,
        "req": "note.add",
        "when": 1660347776,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 243,
          "c00_50": 77,
          "c01_00": 12,
          "csamples": 71,
          "csecs": 60,
          "humidity": 28.541553,
          "pm01_0": 0.35211268,
          "pm01_0_rstd": 1.3662109,
          "pm02_5": 0.5070422,
          "pm02_5_rstd": 1.1484375,
          "pm10_0": 0.5070422,
          "pm10_0_rstd": 1.1484375,
          "pressure": 101316.336,
          "sensor": "pms7003",
          "temperature": 27.039751,
          "voltage": 4.2851562
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660350493,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "31f667d9-0e5b-4bb3-b3e8-e2eb2e5c9236",
        "session": "ae550e74-ae22-490a-9c9a-c2df385f9785",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660350494.505511,
        "req": "note.add",
        "when": 1660348676,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 227,
          "c00_50": 68,
          "c01_00": 10,
          "csamples": 71,
          "csecs": 60,
          "humidity": 29.974329,
          "pm01_0": 0.29577464,
          "pm01_0_rstd": 1.5537109,
          "pm02_5": 0.69014084,
          "pm02_5_rstd": 0.7583008,
          "pm10_0": 0.69014084,
          "pm10_0_rstd": 0.7583008,
          "pressure": 101331.805,
          "sensor": "pms7003",
          "temperature": 26.462873,
          "voltage": 4.28125
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660350493,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "14474d31-4a41-4e87-b2d3-ff6b4ee74089",
        "session": "ae550e74-ae22-490a-9c9a-c2df385f9785",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660350494.510305,
        "req": "note.add",
        "when": 1660349576,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 12,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 453,
          "c00_50": 139,
          "c01_00": 24,
          "c02_50": 2,
          "csamples": 46,
          "csecs": 60,
          "humidity": 30.873953,
          "pm01_0": 1.1521739,
          "pm01_0_rstd": 0.73095703,
          "pm02_5": 2.9130435,
          "pm02_5_rstd": 0.38867188,
          "pm10_0": 2.9130435,
          "pm10_0_rstd": 0.38867188,
          "pressure": 101348.96,
          "sensor": "pms7003",
          "temperature": 25.931515,
          "voltage": 4.2929688
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660350493,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "3806013c-e883-43b1-a68b-ed11d6b6db77",
        "session": "ae550e74-ae22-490a-9c9a-c2df385f9785",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660350494.516125,
        "req": "note.add",
        "when": 1660350476,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 353,
          "c00_50": 104,
          "c01_00": 12,
          "c02_50": 1,
          "c05_00": 1,
          "csamples": 61,
          "csecs": 60,
          "humidity": 31.934174,
          "pm01_0": 0.704918,
          "pm01_0_rstd": 0.91015625,
          "pm02_5": 1.0163934,
          "pm02_5_rstd": 0.8520508,
          "pm10_0": 2.0655737,
          "pm10_0_rstd": 0.77490234,
          "pressure": 101366.45,
          "sensor": "pms7003",
          "temperature": 25.42266,
          "voltage": 4.3007812
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660350493,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "f74fb189-c65c-4325-8bf4-221f0d70a922",
        "session": "e81b68b1-4ce2-4d3d-a5ac-8949c58a61ab",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660354099.564749,
        "req": "note.add",
        "when": 1660351376,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 279,
          "c00_50": 84,
          "c01_00": 10,
          "csamples": 71,
          "csecs": 60,
          "humidity": 33.1587,
          "pm01_0": 0.46478873,
          "pm01_0_rstd": 1.0810547,
          "pm02_5": 0.91549295,
          "pm02_5_rstd": 0.6328125,
          "pm10_0": 0.91549295,
          "pm10_0_rstd": 0.6328125,
          "pressure": 101378.9,
          "sensor": "pms7003",
          "temperature": 24.896421,
          "voltage": 4.2773438
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660354098,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "128f06aa-1723-4f55-97e3-58ac63302d7c",
        "session": "e81b68b1-4ce2-4d3d-a5ac-8949c58a61ab",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660354099.569687,
        "req": "note.add",
        "when": 1660352276,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 5,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 329,
          "c00_50": 100,
          "c01_00": 16,
          "c02_50": 1,
          "c05_00": 1,
          "csamples": 69,
          "csecs": 60,
          "humidity": 34.151966,
          "pm01_0": 0.5652174,
          "pm01_0_rstd": 0.93408203,
          "pm02_5": 1.3333334,
          "pm02_5_rstd": 0.35620117,
          "pm10_0": 1.8985507,
          "pm10_0_rstd": 0.4152832,
          "pressure": 101409.77,
          "sensor": "pms7003",
          "temperature": 24.465818,
          "voltage": 4.2773438
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660354098,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "01b3703f-388d-4114-9fc7-b994bf5b3d5e",
        "session": "e81b68b1-4ce2-4d3d-a5ac-8949c58a61ab",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660354099.574409,
        "req": "note.add",
        "when": 1660353176,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 279,
          "c00_50": 85,
          "c01_00": 10,
          "c02_50": 1,
          "c05_00": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 35.49507,
          "pm01_0": 0.3943662,
          "pm01_0_rstd": 1.2480469,
          "pm02_5": 0.6619718,
          "pm02_5_rstd": 1.1962891,
          "pm10_0": 1.7605634,
          "pm10_0_rstd": 0.5878906,
          "pressure": 101426.305,
          "sensor": "pms7003",
          "temperature": 24.080732,
          "voltage": 4.2695312
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660354098,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "10622c5e-0265-4b84-8d75-d6fabf125751",
        "session": "e81b68b1-4ce2-4d3d-a5ac-8949c58a61ab",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660354099.578608,
        "req": "note.add",
        "when": 1660354076,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 350,
          "c00_50": 101,
          "c01_00": 11,
          "csamples": 67,
          "csecs": 60,
          "humidity": 36.231262,
          "pm01_0": 0.52238804,
          "pm01_0_rstd": 1.1230469,
          "pm02_5": 1.0597014,
          "pm02_5_rstd": 0.7504883,
          "pm10_0": 1.0597014,
          "pm10_0_rstd": 0.7504883,
          "pressure": 101443.31,
          "sensor": "pms7003",
          "temperature": 23.70792,
          "voltage": 4.2890625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660354098,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "21b3b5a1-1bc8-4fae-8d5a-751ca63e07a6",
        "session": "b77865a1-5e36-4d57-b9c7-98a3034d250e",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660357700.365835,
        "req": "note.add",
        "when": 1660354976,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 352,
          "c00_50": 102,
          "c01_00": 13,
          "csamples": 71,
          "csecs": 60,
          "humidity": 36.890827,
          "pm01_0": 0.15492958,
          "pm01_0_rstd": 2.3515625,
          "pm02_5": 0.9859155,
          "pm02_5_rstd": 0.49975586,
          "pm10_0": 0.9859155,
          "pm10_0_rstd": 0.49975586,
          "pressure": 101455.88,
          "sensor": "pms7003",
          "temperature": 23.375,
          "voltage": 4.2734375
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660357699,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "31f854d8-21b7-4711-b681-de04d9b5544d",
        "session": "b77865a1-5e36-4d57-b9c7-98a3034d250e",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660357700.371203,
        "req": "note.add",
        "when": 1660355876,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 8,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 412,
          "c00_50": 129,
          "c01_00": 20,
          "c02_50": 1,
          "csamples": 48,
          "csecs": 60,
          "humidity": 36.926254,
          "pm01_0": 1.0833334,
          "pm01_0_rstd": 0.65478516,
          "pm02_5": 2.0833333,
          "pm02_5_rstd": 0.4182129,
          "pm10_0": 2.6666667,
          "pm10_0_rstd": 0.4260254,
          "pressure": 101459.54,
          "sensor": "pms7003",
          "temperature": 23.070208,
          "voltage": 4.2695312
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660357699,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "6c2cd937-ff27-4ae8-bb4b-842a57a277d8",
        "session": "b77865a1-5e36-4d57-b9c7-98a3034d250e",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660357700.376163,
        "req": "note.add",
        "when": 1660356776,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 319,
          "c00_50": 96,
          "c01_00": 14,
          "csamples": 71,
          "csecs": 60,
          "humidity": 36.90831,
          "pm01_0": 0.2112676,
          "pm01_0_rstd": 1.9462891,
          "pm02_5": 0.92957747,
          "pm02_5_rstd": 0.6118164,
          "pm10_0": 0.92957747,
          "pm10_0_rstd": 0.6118164,
          "pressure": 101466.29,
          "sensor": "pms7003",
          "temperature": 22.850819,
          "voltage": 4.2695312
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660357699,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "3b445a0b-4de0-40ce-b587-1f6f8c9f4bdc",
        "session": "b77865a1-5e36-4d57-b9c7-98a3034d250e",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660357700.381239,
        "req": "note.add",
        "when": 1660357677,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 9,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 369,
          "c00_50": 115,
          "c01_00": 21,
          "c02_50": 2,
          "csamples": 66,
          "csecs": 60,
          "humidity": 37.345154,
          "pm01_0": 0.6969697,
          "pm01_0_rstd": 0.8334961,
          "pm02_5": 2.2878788,
          "pm02_5_rstd": 0.4321289,
          "pm10_0": 2.2878788,
          "pm10_0_rstd": 0.4321289,
          "pressure": 101472.82,
          "sensor": "pms7003",
          "temperature": 22.539892,
          "voltage": 4.2851562
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660357699,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "ccfae646-378f-482f-89c6-cda77bdbc6c5",
        "session": "c4b622fe-c723-428e-9460-0d82e34f0654",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660361299.58766,
        "req": "note.add",
        "when": 1660358576,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 10,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 419,
          "c00_50": 130,
          "c01_00": 20,
          "c02_50": 2,
          "csamples": 60,
          "csecs": 60,
          "humidity": 37.249115,
          "pm01_0": 0.9166667,
          "pm01_0_rstd": 0.7324219,
          "pm02_5": 2.45,
          "pm02_5_rstd": 0.29516602,
          "pm10_0": 2.45,
          "pm10_0_rstd": 0.29516602,
          "pressure": 101476.56,
          "sensor": "pms7003",
          "temperature": 22.283173,
          "voltage": 4.265625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660361298,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "bb88a35b-5496-4334-a094-3efe7e57d79d",
        "session": "c4b622fe-c723-428e-9460-0d82e34f0654",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660361299.592278,
        "req": "note.add",
        "when": 1660359476,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 6,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 372,
          "c00_50": 112,
          "c01_00": 15,
          "csamples": 71,
          "csecs": 60,
          "humidity": 37.231026,
          "pm01_0": 0.43661973,
          "pm01_0_rstd": 1.1435547,
          "pm02_5": 1.5492958,
          "pm02_5_rstd": 0.5541992,
          "pm10_0": 1.6619718,
          "pm10_0_rstd": 0.6098633,
          "pressure": 101489.34,
          "sensor": "pms7003",
          "temperature": 22.05765,
          "voltage": 4.265625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660361298,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "885cb9f4-de91-4676-9d78-6998751e8e2d",
        "session": "c4b622fe-c723-428e-9460-0d82e34f0654",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660361299.597134,
        "req": "note.add",
        "when": 1660360376,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 7,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 310,
          "c00_50": 90,
          "c01_00": 19,
          "c02_50": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 37.298054,
          "pm01_0": 0.53521127,
          "pm01_0_rstd": 0.93847656,
          "pm02_5": 1.7605634,
          "pm02_5_rstd": 0.5029297,
          "pm10_0": 1.7605634,
          "pm10_0_rstd": 0.5029297,
          "pressure": 101493.875,
          "sensor": "pms7003",
          "temperature": 21.824455,
          "voltage": 4.2617188
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660361298,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "81d4cb47-0dcb-4aff-9ac4-8895e8a1ed3b",
        "session": "c4b622fe-c723-428e-9460-0d82e34f0654",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660361299.601374,
        "req": "note.add",
        "when": 1660361276,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 5,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 367,
          "c00_50": 111,
          "c01_00": 18,
          "csamples": 71,
          "csecs": 60,
          "humidity": 37.71443,
          "pm01_0": 0.3802817,
          "pm01_0_rstd": 1.2861328,
          "pm02_5": 1.3521127,
          "pm02_5_rstd": 0.3972168,
          "pm10_0": 1.3521127,
          "pm10_0_rstd": 0.3972168,
          "pressure": 101500.59,
          "sensor": "pms7003",
          "temperature": 21.573875,
          "voltage": 4.28125
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660361298,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "f7cb2d7e-aee7-40c7-b6c6-ff12d6dafbc2",
        "session": "4aaa75f2-32f2-45c8-8808-79308463f097",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660364899.390571,
        "req": "note.add",
        "when": 1660362176,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 284,
          "c00_50": 89,
          "c01_00": 9,
          "csamples": 71,
          "csecs": 60,
          "humidity": 38.671345,
          "pm01_0": 0.4225352,
          "pm01_0_rstd": 1.1777344,
          "pm02_5": 0.57746476,
          "pm02_5_rstd": 1.1210938,
          "pm10_0": 1.2112676,
          "pm10_0_rstd": 0.88183594,
          "pressure": 101513.36,
          "sensor": "pms7003",
          "temperature": 21.30642,
          "voltage": 4.2578125
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660364898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "f79f587c-1e3d-4d3e-a768-7c7297f32df9",
        "session": "4aaa75f2-32f2-45c8-8808-79308463f097",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660364899.392143,
        "req": "note.add",
        "when": 1660363076,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 1,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 248,
          "c00_50": 72,
          "c01_00": 10,
          "csamples": 71,
          "csecs": 60,
          "humidity": 39.011875,
          "pm01_0": 0.12676056,
          "pm01_0_rstd": 2.6425781,
          "pm02_5": 0.23943663,
          "pm02_5_rstd": 1.7949219,
          "pm10_0": 0.23943663,
          "pm10_0_rstd": 1.7949219,
          "pressure": 101533.49,
          "sensor": "pms7003",
          "temperature": 21.046125,
          "voltage": 4.2578125
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660364898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "59a96b8d-b173-473d-93a0-301d96bd943b",
        "session": "4aaa75f2-32f2-45c8-8808-79308463f097",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660364899.393534,
        "req": "note.add",
        "when": 1660363976,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 3,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 267,
          "c00_50": 82,
          "c01_00": 10,
          "csamples": 69,
          "csecs": 60,
          "humidity": 39.689835,
          "pm01_0": 0.3043478,
          "pm01_0_rstd": 1.6240234,
          "pm02_5": 0.73913044,
          "pm02_5_rstd": 0.9746094,
          "pm10_0": 0.73913044,
          "pm10_0_rstd": 0.9746094,
          "pressure": 101565.39,
          "sensor": "pms7003",
          "temperature": 20.880436,
          "voltage": 4.265625
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660364898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "d11e82bc-ee37-473d-b369-e99f6503e7f5",
        "session": "4aaa75f2-32f2-45c8-8808-79308463f097",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660364899.394868,
        "req": "note.add",
        "when": 1660364876,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 271,
          "c00_50": 79,
          "c01_00": 9,
          "c02_50": 2,
          "c05_00": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 40.39965,
          "pm01_0": 0.2112676,
          "pm01_0_rstd": 1.9462891,
          "pm02_5": 0.5915493,
          "pm02_5_rstd": 1.0136719,
          "pm10_0": 1.5211267,
          "pm10_0_rstd": 0.9355469,
          "pressure": 101569.45,
          "sensor": "pms7003",
          "temperature": 20.627302,
          "voltage": 4.2773438
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660364898,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "a7583886-7a78-491f-a05e-ca00b98d42eb",
        "session": "9a59012a-4298-443b-8618-3fc82d1a0fba",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660368499.482745,
        "req": "note.add",
        "when": 1660365776,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 1,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 220,
          "c00_50": 65,
          "c01_00": 6,
          "csamples": 71,
          "csecs": 60,
          "humidity": 40.46577,
          "pm01_0": 0.1971831,
          "pm01_0_rstd": 2.03125,
          "pm02_5": 0.23943663,
          "pm02_5_rstd": 2.171875,
          "pm10_0": 0.23943663,
          "pm10_0_rstd": 2.171875,
          "pressure": 101568.85,
          "sensor": "pms7003",
          "temperature": 20.408941,
          "voltage": 4.2539062
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660368498,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "2a234321-8b50-4d5e-be2b-25af88b8944a",
        "session": "9a59012a-4298-443b-8618-3fc82d1a0fba",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660368499.484223,
        "req": "note.add",
        "when": 1660366676,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 268,
          "c00_50": 80,
          "c01_00": 15,
          "csamples": 71,
          "csecs": 60,
          "humidity": 40.755642,
          "pm01_0": 0.1971831,
          "pm01_0_rstd": 2.03125,
          "pm02_5": 0.45070422,
          "pm02_5_rstd": 1.2314453,
          "pm10_0": 0.45070422,
          "pm10_0_rstd": 1.2314453,
          "pressure": 101569,
          "sensor": "pms7003",
          "temperature": 20.202856,
          "voltage": 4.2539062
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660368498,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "8ecdd114-00e4-4621-ae77-e6b71c3383d2",
        "session": "9a59012a-4298-443b-8618-3fc82d1a0fba",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660368499.485481,
        "req": "note.add",
        "when": 1660367576,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 1,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 238,
          "c00_50": 73,
          "c01_00": 12,
          "csamples": 71,
          "csecs": 60,
          "humidity": 41.85378,
          "pm01_0": 0.22535211,
          "pm01_0_rstd": 1.8671875,
          "pm02_5": 0.32394367,
          "pm02_5_rstd": 1.7128906,
          "pm10_0": 0.32394367,
          "pm10_0_rstd": 1.7128906,
          "pressure": 101563.75,
          "sensor": "pms7003",
          "temperature": 19.897562,
          "voltage": 4.2617188
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660368498,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "9b5eaf8f-12a3-46d8-a230-21a4a7688f2c",
        "session": "9a59012a-4298-443b-8618-3fc82d1a0fba",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660368499.486676,
        "req": "note.add",
        "when": 1660368476,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 0,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 192,
          "c00_50": 59,
          "c01_00": 8,
          "csamples": 71,
          "csecs": 60,
          "humidity": 42.73138,
          "pm01_0": 0.028169014,
          "pm01_0_rstd": 5.9140625,
          "pm02_5": 0.056338027,
          "pm02_5_rstd": 4.1210938,
          "pm10_0": 0.056338027,
          "pm10_0_rstd": 4.1210938,
          "pressure": 101562.11,
          "sensor": "pms7003",
          "temperature": 19.61426,
          "voltage": 4.2734375
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660368498,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "6b7d14f2-374d-426c-addb-4f23f7892333",
        "session": "6173cf82-2f7a-4590-abfc-2ababfcc14b3",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660372095.755664,
        "req": "note.add",
        "when": 1660369376,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 0,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 222,
          "c00_50": 66,
          "c01_00": 14,
          "csamples": 71,
          "csecs": 60,
          "humidity": 43.55242,
          "pm02_5": 0.1971831,
          "pm02_5_rstd": 2.03125,
          "pm10_0": 0.1971831,
          "pm10_0_rstd": 2.03125,
          "pressure": 101552.625,
          "sensor": "pms7003",
          "temperature": 19.373913,
          "voltage": 4.2460938
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660372094,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "baf879d3-54d1-4462-b3c9-16d39528df12",
        "session": "6173cf82-2f7a-4590-abfc-2ababfcc14b3",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660372095.760473,
        "req": "note.add",
        "when": 1660370276,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 2,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 272,
          "c00_50": 87,
          "c01_00": 14,
          "c02_50": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 44.332985,
          "pm01_0": 0.112676054,
          "pm01_0_rstd": 2.8261719,
          "pm02_5": 0.64788735,
          "pm02_5_rstd": 0.90771484,
          "pm10_0": 1.1549295,
          "pm10_0_rstd": 0.63183594,
          "pressure": 101553.32,
          "sensor": "pms7003",
          "temperature": 19.126408,
          "voltage": 4.2460938
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660372094,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "481974eb-f208-4575-9340-d7c3df39ddb6",
        "session": "6173cf82-2f7a-4590-abfc-2ababfcc14b3",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660372095.765893,
        "req": "note.add",
        "when": 1660371176,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 342,
          "c00_50": 105,
          "c01_00": 11,
          "c02_50": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 45.204052,
          "pm01_0": 0.53521127,
          "pm01_0_rstd": 0.93847656,
          "pm02_5": 1.0704225,
          "pm02_5_rstd": 0.7290039,
          "pm10_0": 1.5352113,
          "pm10_0_rstd": 0.53759766,
          "pressure": 101554.78,
          "sensor": "pms7003",
          "temperature": 18.910097,
          "voltage": 4.2460938
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660372094,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "8b59ea48-d885-41c4-9a4d-33175d33e9a7",
        "session": "6173cf82-2f7a-4590-abfc-2ababfcc14b3",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660372095.771301,
        "req": "note.add",
        "when": 1660372076,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 3,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 310,
          "c00_50": 84,
          "c01_00": 15,
          "c02_50": 2,
          "csamples": 71,
          "csecs": 60,
          "humidity": 45.978317,
          "pm01_0": 0.056338027,
          "pm01_0_rstd": 4.1210938,
          "pm02_5": 0.8169014,
          "pm02_5_rstd": 0.5966797,
          "pm10_0": 0.8169014,
          "pm10_0_rstd": 0.5966797,
          "pressure": 101555.93,
          "sensor": "pms7003",
          "temperature": 18.699411,
          "voltage": 4.2617188
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660372094,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "3f6cf2d6-a6a1-4f67-9068-44511fab515e",
        "session": "4b441850-de00-426b-ae10-b76b0a3f1519",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660375699.728576,
        "req": "note.add",
        "when": 1660372976,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 4,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 316,
          "c00_50": 99,
          "c01_00": 14,
          "c02_50": 1,
          "csamples": 71,
          "csecs": 60,
          "humidity": 46.975384,
          "pm01_0": 0.4225352,
          "pm01_0_rstd": 1.1777344,
          "pm02_5": 0.91549295,
          "pm02_5_rstd": 0.7089844,
          "pm10_0": 0.91549295,
          "pm10_0_rstd": 0.7089844,
          "pressure": 101548.445,
          "sensor": "pms7003",
          "temperature": 18.490261,
          "voltage": 4.2421875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660375698,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      },
      {
        "event": "424f7c4a-6bd0-4171-adcf-e1f0748035b4",
        "session": "4b441850-de00-426b-ae10-b76b0a3f1519",
        "best_id": "IG AQM041",
        "device": "dev:864475044231362",
        "sn": "IG AQM041",
        "product": "product:org.airnote.solar.air.v1",
        "received": 1660375699.733955,
        "req": "note.add",
        "when": 1660373876,
        "file": "_air.qo",
        "updates": 1,
        "body": {
          "aqi": 1,
          "aqi_algorithm": "cf-atm",
          "aqi_level": "good",
          "c00_30": 237,
          "c00_50": 76,
          "c01_00": 10,
          "csamples": 71,
          "csecs": 60,
          "humidity": 47.582428,
          "pm01_0": 0.07042254,
          "pm01_0_rstd": 3.6582031,
          "pm02_5": 0.30985916,
          "pm02_5_rstd": 1.6894531,
          "pm10_0": 0.30985916,
          "pm10_0_rstd": 1.6894531,
          "pressure": 101548.14,
          "sensor": "pms7003",
          "temperature": 18.32253,
          "voltage": 4.2421875
        },
        "best_location_type": "gps",
        "best_lat": 39.9556125,
        "best_lon": -75.23596484375,
        "best_location": "Millbourne PA",
        "best_country": "US",
        "best_timezone": "America/New_York",
        "where_olc": "87F6XQ47+6JVC",
        "where_lat": 39.9556125,
        "where_lon": -75.23596484375,
        "where_location": "Millbourne PA",
        "where_country": "US",
        "where_timezone": "America/New_York",
        "tower_when": 1660375698,
        "tower_lat": 39.949806,
        "tower_lon": -75.242095,
        "tower_country": "US",
        "tower_location": "Philadelphia Pennsylvania",
        "tower_timezone": "America/New_York",
        "tower_id": "310,410,293,5529361"
      }
    ]
  }

  export default response; 